import {
  BH_BASE_URL,
  GRAPESHOT_API_ENDPOINT,
  IS_PLAYWRIGHT_TEST,
} from "@helper/getEnvVariables";
import {
  removeLeadingSlash,
  removeTrailingSlash,
} from "@helper/removeTrailingLeadingSlash";
import { useCallback, useEffect, useMemo, useState } from "react";

type GrapeshotResult = {
  channels: {
    name: string;
  }[];
};

export function useGrapeshotData(urlPath: string) {
  const [gsChannels, setGsChannels] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchGsChannels = useCallback(
    async (urlPath: string): Promise<string[]> => {
      if (IS_PLAYWRIGHT_TEST === "true") {
        return ["no_analysis"];
      }
      try {
        const response = await fetch(
          `${GRAPESHOT_API_ENDPOINT}${removeTrailingSlash(BH_BASE_URL)}/${removeLeadingSlash(urlPath)}`,
          {
            method: "GET",
          },
        );

        const processedData = (await response.json()) as GrapeshotResult;
        const channelNames = processedData.channels.map(
          (channel) => channel.name,
        );
        return channelNames;
      } catch (e) {
        return [];
      }
    },
    [],
  );

  useEffect(() => {
    const callFetch = async () => {
      if (urlPath === "") {
        setIsLoading(false);
        return;
      }

      const gsData = await fetchGsChannels(urlPath);
      setGsChannels(gsData);
      setIsLoading(false);
    };

    void callFetch();
  }, [urlPath, fetchGsChannels]);

  return useMemo(() => ({ gsChannels, isLoading }), [gsChannels, isLoading]);
}
